export type ResourceLink = {
	label: string
	url: string
}

export type BeginnerStep = {
	step: number
	title: string
	description?: string
	links: ResourceLink[]
}

export const beginnerSteps: BeginnerStep[] = [
	{
		step: 1,
		title: "Создаём площадку",
		description:
			"Полноценное вводное обучение по YouTube и вертикальному формату: посмотрите курс и пройдите чек‑лист запуска канала.",
		links: [
			{
				label: "Курс YouTube с нуля — Часть 1",
				url: "https://t.me/c/2357546125/536",
			},
			{
				label: "Курс YouTube с нуля — Часть 2",
				url: "https://t.me/c/2357546125/542",
			},
			{
				label: "Чек-лист: Как запустить YouTube-канал с нуля",
				url: "https://t.me/c/2357546125/353",
			},
			{
				label: "Курс «Рилсы миллионники» — Часть 1",
				url: "https://t.me/c/2357546125/647",
			},
			{
				label: "Курс «Рилсы миллионники» — Часть 2",
				url: "https://t.me/c/2357546125/653",
			},
		],
	},
	{
		step: 2,
		title: "Оформляем канал",
		description:
			"Оформите главную страницу так, чтобы сразу было понятно, про что канал и что здесь смотреть.",
		links: [
			{
				label: "Гайд по оформлению главной страницы YouTube",
				url: "https://t.me/c/2357546125/953",
			},
		],
	},
	{
		step: 3,
		title: "Стратегия",
		description:
			"Определяемся, для чего нужен YouTube‑канал, и составляем план достижения конкретных результатов.",
		links: [
			{
				label: "Урок по стратегии",
				url: "https://t.me/c/2357546125/68",
			},
		],
	},
	{
		step: 4,
		title: "Насмотренность",
		description:
			"Базовый инструмент, чтобы не тратить время вслепую: смотрим, как выглядит хороший контент в вашей нише, что работает и что не работает.",
		links: [
			{
				label: "Шаблон и урок по насмотренности",
				url: "https://t.me/c/2357546125/40",
			},
		],
	},
	{
		step: 5,
		title: "ВИСП",
		description:
			"Смотрите уроки по порядку, найдите матрицу под свою нишу и примените на своих видео: проверьте названия и превью по ВИСПу.",
		links: [
			{
				label: "Базовый урок по технике ВИСП",
				url: "https://t.me/c/2357546125/34",
			},
			{
				label: "ВИСП в Shorts / Reels (доп. урок)",
				url: "https://t.me/c/2357546125/201",
			},
			{
				label: "Ещё один доп. урок по ВИСП (кейсы)",
				url: "https://t.me/c/2357546125/628",
			},
			{
				label: "Заголовок по технике ВИСП",
				url: "https://t.me/c/2357546125/222",
			},
			{
				label: "ВИСП в вертикальном формате (Shorts)",
				url: "https://t.me/c/2357546125/254",
			},
			{
				label: "Как прокачать сценарии по ВИСП",
				url: "https://t.me/c/2357546125/350",
			},
			{
				label: "Скринкаст проверки превью по ВИСП",
				url: "https://t.me/c/2357546125/251",
			},
			{
				label: "Разборы каналов по ВИСПу",
				url: "https://t.me/c/2357546125/755",
			},
			{
				label: "Инструкция: как пользоваться таблицей",
				url: "https://t.me/c/2357546125/239",
			},
			{
				label: "Оригинальная таблица-шаблон для ВИСП",
				url: "https://t.me/c/2357546125/202",
			},
			{
				label: "Матрица ВИСП: ниша «Здоровье»",
				url: "https://t.me/c/2357546125/239",
			},
			{
				label: "Матрица ВИСП: ниша «Стоматология»",
				url: "https://t.me/c/2357546125/627",
			},
			{
				label: "Матрица ВИСП: «Недвижимость» — Часть 1",
				url: "https://t.me/c/2357546125/262",
			},
			{
				label: "Матрица ВИСП: «Недвижимость» — Часть 2",
				url: "https://t.me/c/2357546125/371",
			},
			{
				label: "Матрица ВИСП: ниша «Криптовалюты»",
				url: "https://t.me/c/2357546125/286",
			},
			{
				label: "Матрица ВИСП: ниша «Юриспруденция»",
				url: "https://t.me/c/2357546125/326",
			},
			{
				label: "Матрица ВИСП: ниша «Нейросети»",
				url: "https://t.me/c/2357546125/550",
			},
			{
				label: "Матрица ВИСП: ниша «Продюсирование»",
				url: "https://t.me/c/2357546125/768",
			},
			{
				label: "Матрица ВИСП: «Психология / саморазвитие»",
				url: "https://t.me/c/2357546125/793",
			},
			{
				label: "Матрица ВИСП: ниша «Эзотерика»",
				url: "https://t.me/c/2357546125/916",
			},
		],
	},
	{
		step: 6,
		title: "Лестница Ханта (аудитория)",
		description:
			"Инструмент, который помогает понять, на какой стадии осознания находится аудитория. Разные ступени Ханта → разные подходы к темам и сценариям.",
		links: [
			{
				label: "Урок по Лестнице Ханта",
				url: "https://t.me/c/2357546125/304",
			},
			{
				label: "Шаблон Лестницы Ханта",
				url: "https://t.me/c/2357546125/71",
			},
			{
				label: "Объяснение важной ступени (контент‑маркетинг)",
				url: "https://t.me/c/2357546125/701",
			},
			{
				label: "Созвон с лидерами 20ок на тему Лестницы Ханта",
				url: "https://t.me/c/2357546125/702",
			},
		],
	},
	{
		step: 7,
		title: "Контент-план",
		description:
			"Дорожная карта к просмотрам/клиентам/деньгам. Сначала пройдите уроки по порядку, затем заполните план хотя бы на 14 дней: 5–10 конкретных тем с референсами и превью.",
		links: [
			{
				label: "Урок по контент-планам",
				url: "https://t.me/c/2357546125/48",
			},
			{
				label: "Шаблон для составления контент-плана",
				url: "https://t.me/c/2357546125/49",
			},
			{
				label: "Эфир с проверкой ваших контент-планов",
				url: "https://t.me/c/2357546125/62",
			},
			{
				label: "Как сделать КП, в котором клиент не сбреет темы",
				url: "https://t.me/c/2357546125/369",
			},
			{
				label: "Матрица бесконечного контента",
				url: "https://t.me/c/2357546125/379",
			},
			{
				label: "Эфир: составляю готовые КП по вашим нишам",
				url: "https://t.me/c/2357546125/814",
			},
			{
				label: "Готовый контент-план: ниша «Маркетинг»",
				url: "https://t.me/c/2357546125/303",
			},
			{
				label: "Готовый контент-план: ниша «Строительство»",
				url: "https://t.me/c/2357546125/347",
			},
			{
				label: "Готовый контент-план: «Личный бренд / Мотивация»",
				url: "https://t.me/c/2357546125/412",
			},
			{
				label: "Готовый контент-план: ниша «Финансы»",
				url: "https://t.me/c/2357546125/517",
			},
			{
				label: "Готовый контент-план: ниша «Нутрициология»",
				url: "https://t.me/c/2357546125/592",
			},
			{
				label: "Готовый контент-план: ниша «Медицина»",
				url: "https://t.me/c/2357546125/801",
			},
		],
	},
	{
		step: 8,
		title: "Пишем сценарии",
		description:
			"Алгоритм: смотрите курс → пишете первый сценарий → проверяете и правите по эфиру с проверкой сценариев.",
		links: [
			{
				label: "Курс по сценариям длинных видео",
				url: "https://t.me/c/2357546125/878",
			},
			{
				label: "Эфир с проверкой ваших сценариев",
				url: "https://t.me/c/2357546125/968",
			},
		],
	},
	{
		step: 9,
		title: "Подготовка к съёмке",
		description:
			"Соберите всё необходимое до записи: план, тезисы и организацию процесса, чтобы съёмка прошла без хаоса.",
		links: [],
	},
	{
		step: 10,
		title: "Пробуем сниматься",
		description:
			"Разбираем съёмку с оператором: стоимость смены, как отличить дилетанта от профи, как оператор может испортить съёмку, и кому можно снимать на iPhone.",
		links: [
			{
				label: "Эфир с Женей Игнатовым (операторы студии)",
				url: "https://t.me/c/2357546125/789",
			},
		],
	},
	{
		step: 11,
		title: "Снимаем и монтируем",
		description:
			"Организуем процесс съёмки и монтажа: что учесть после съёмки, как монтировать самому или как нанять монтажёра и ставить ТЗ без 100500 правок.",
		links: [
			{
				label: "Таблица после съёмки (чек‑лист)",
				url: "https://t.me/c/2357546125/56",
			},
			{
				label: "Урок по основам монтажа (если монтируете сами)",
				url: "https://t.me/c/2357546125/607",
			},
			{
				label: "Эфир: как нанять монтажёра и ставить ТЗ",
				url: "https://t.me/c/2357546125/980",
			},
		],
	},
	{
		step: 12,
		title: "Делаем превью",
		description: "Делаем превью, на которые кликнут.",
		links: [
			{
				label: "Курс по превью, на которые 100% кликнут",
				url: "https://t.me/c/2357546125/168",
			},
		],
	},
	{
		step: 13,
		title: "SEO перед публикацией",
		description:
			"Разбираемся, что такое SEO на YouTube, зачем оно нужно, и как писать SEO (в том числе с помощью ChatGPT).",
		links: [
			{
				label: "Что такое SEO на YouTube",
				url: "https://t.me/c/2357546125/85",
			},
			{
				label: "Эфир по SEO",
				url: "https://t.me/c/2357546125/407",
			},
			{
				label: "Как писать SEO с помощью ChatGPT",
				url: "https://t.me/c/2357546125/429",
			},
		],
	},
	{
		step: 14,
		title: "Публикуем длинное видео",
		description: "Перед публикацией пройдите чек‑лист: что важно сделать перед выпуском.",
		links: [
			{
				label: "Чек-лист: что важно сделать перед публикацией",
				url: "https://t.me/c/2357546125/165",
			},
		],
	},
	{
		step: 15,
		title: "Публикуем 3 Shorts’а",
		description: "Публикуем 3 Shorts’а.",
		links: [],
	},
]
